// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__yQY6x","modalFooterButton":"ModalNotes_modalFooterButton__3PrU5"};